exports.default = "<li> <a href=\"${model.url}\"> ${model.label}</a> </li>";